export function ContactInfo({onNavigateToTop}) {

  return (
    <div className="md:w-1/3 space-y-6">
      <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200">
        <h3 className="text-xl font-bold text-gray-900 mb-4">
          Contact Information
        </h3>

        <div className="space-y-4">
          <p className="text-gray-600">
            <strong>Email:</strong>
            {' '}
            info@secureonelabs.com
          </p>

          <p className="text-gray-600">
            <strong>Address:</strong>
            <br />
            SecureOneLabs
            <br />
            701 Tillery Street #12
            <br />
            Austin, Texas 78702
            <br />
            United States
          </p>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200">
        <h3 className="text-xl font-bold text-gray-900 mb-4">
          Technical Support
        </h3>

        <p className="text-gray-600 mb-4">
          Need help with BOSSS? Our dedicated technical support team
          provides assistance for all
          platform-related questions.
        </p>

        <button
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-all duration-200 hover:scale-105"
          onClick={() => onNavigateToTop('/services/support')}
        >
          Visit Support Portal
        </button>
      </div>
    </div>
  );
}
